/** Mensaje legible desde Error, PostgrestError u otros throws de red. */
export function getErrorMessage(error: unknown, fallback = 'Ocurrió un error.'): string {
  if (error instanceof Error) {
    const msg = error.message.trim();
    // `new Error(objeto)` produce este literal; no sirve como copy de UI.
    if (!msg || msg === '[object Object]') return fallback;
    return msg;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    const msg = (error as { message: unknown }).message;
    if (typeof msg === 'string' && msg.trim() && msg.trim() !== '[object Object]') {
      return msg.trim();
    }
  }
  if (typeof error === 'string' && error.trim() && error.trim() !== '[object Object]') {
    return error.trim();
  }
  return fallback;
}
